// Sprint CAL-1b — scheda della colonna del calendario che si apre e chiude con ▾/▴ (stato ricordato nel browser)
import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { leggiLS, scriviLS } from "./calendarioComuni";

export function SchedaRichiudibile({ chiave, titolo, testid, azioni, children }) {
  const [aperta, setAperta] = useState(() => leggiLS(chiave, true) !== false);
  const cambia = () => { setAperta(!aperta); scriviLS(chiave, !aperta); };
  return (
    <Card className="p-3 space-y-2" data-testid={testid}>
      <div className="flex items-center gap-2">
        <button type="button" onClick={cambia} aria-expanded={aperta} data-testid={`${testid}-apri`}
          className="flex-1 min-w-0 flex items-center justify-between gap-2 text-sm font-semibold text-slate-800 text-left">
          <span className="truncate" data-testid={`${testid}-titolo`}>{titolo}</span><span aria-hidden>{aperta ? "▴" : "▾"}</span></button>
        {azioni}
      </div>
      {aperta && children}
    </Card>
  );
}
